import api from "@/services/api.service";
import store from "@/store/";
import { responses } from "@/store/responses";

// Should the user be warned for being the last operator
export async function warnLastOperator(userId: number = null): Promise<boolean> {
	// If we arent suplied with a userid get the current user from the store (if that fails return false)
	if (!userId) {
		userId = store.state.User.userId;
		if (!userId) {
			return false;
		}
	}

	// Feature Flag Enabled?
	const isWarnLastOperatorEnabled = store.getters["getFeature"](["Alarms", "WarnLastOperator"]);

	if (isWarnLastOperatorEnabled) {
		// Is the Warning message already being shown?
		const isVisible = store.state.siteMonitor.LastOperatorMessageVisible;

		// Is the user the last operator?
		const isLastOperator = await getIsLastOperator(userId);

		if (isLastOperator && !isVisible) return true;
	} else {
		return false;
	}
}

async function getIsLastOperator(userId: number): Promise<boolean> {
	const response = await api.getIsLastOperator(userId);

	return userId && userId > 0 ? response.data : false;
}
